import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-map-all-shows-error-modal',
  templateUrl: './map-all-shows-error-modal.component.html',
  styleUrls: ['./map-all-shows-error-modal.component.scss']
})
export class MapAllShowsErrorModalComponent implements OnInit {

  unMappedCount = 7;  //need to track this in the service file

  constructor(public dialogRef: MatDialogRef<MapAllShowsErrorModalComponent>) { }

  ngOnInit() {
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
